module.exports = __webpack_public_path__ + "0c6248d9210ac64d26c450126bac35ca.svg";